import React from 'react'

export default function VendorList() {
  return (
   <div
              id="vendors-list-card"
              className="bg-white rounded-2xl shadow-sm border border-[#e5e7eb] px-7 py-6"
            >
              <div className="font-semibold text-lg text-[#1e293b] mb-4">
                Top Vendors
              </div>
              <ul className="flex flex-col gap-4">
                <li className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-[#eff6ff] rounded-full flex items-center justify-center">
                    <i className="fa-solid fa-building text-[#3b82f6] text-lg"></i>
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-[#1e293b]">MediLife</div>
                    <div className="text-xs text-[#94a3b8]">154 products</div>
                  </div>
                  <span className="text-[#10b981] font-bold text-sm">+12%</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-[#e0e7ff] rounded-full flex items-center justify-center">
                    <i className="fa-solid fa-building text-[#6366f1] text-lg"></i>
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-[#1e293b]">
                      HealthCarePro
                    </div>
                    <div className="text-xs text-[#94a3b8]">97 products</div>
                  </div>
                  <span className="text-[#ef4444] font-bold text-sm">-5%</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-[#d1fae5] rounded-full flex items-center justify-center">
                    <i className="fa-solid fa-building text-[#10b981] text-lg"></i>
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-[#1e293b]">
                      Lifeline Supplies
                    </div>
                    <div className="text-xs text-[#94a3b8]">80 products</div>
                  </div>
                  <span className="text-[#10b981] font-bold text-sm">+7%</span>
                </li>
              </ul>
            </div>
  )
}
